<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p [innerHtml]="message"></p>  
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">{{cancelText}}</button>
  <button mat-button (click)="confirm()" cdkFocusInitial>{{confirmText}}</button>
</div>